import { FunctionComponent } from 'react';
import AnimateHeight from 'react-animate-height';

import styles from './ErrorText.module.scss';

type Size = 'sm' | 'md' | 'lg';

export type ErrorTextProps = {
  error?: string | string[] | null;
  size?: Size;
  fontSize?: string;
  indentation?: boolean;
  fitContent?: boolean;
};

type FC = FunctionComponent<ErrorTextProps>;

const ErrorText: FC = ({ error, size = 'md', fontSize, indentation = false, fitContent = false }: ErrorTextProps) => (
  <AnimateHeight
    id="textfield-error-height"
    duration={200}
    easing="ease-in-out"
    height={error ? getAnimationHeight(size, fitContent) : 0}
  >
    <div
      className={[styles.error, styles[size], styles[indentation ? 'indent' : '']].join(' ')}
      style={{ fontSize }}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: error ? error.toString() : '' }}
    />
  </AnimateHeight>
);

function getAnimationHeight(size: Size, fitContent: boolean) {
  if (fitContent) {
    return 'auto';
  }
  const heights = {
    sm: 26,
    md: 30,
    lg: 40,
  };

  return heights[size];
}

export default ErrorText;
